// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file shifts/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.ShiftDetails
 */
export class ShiftDetails extends Message<ShiftDetails> {
  /**
   * @generated from field: string shift_id = 1;
   */
  shiftId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: bool system_ended = 5;
   */
  systemEnded = false;

  /**
   * @generated from field: float calculated_total_hours = 6;
   */
  calculatedTotalHours = 0;

  /**
   * @generated from field: com.neulink.pharmacy.ShiftInternalDetails details = 7;
   */
  details?: ShiftInternalDetails;

  /**
   * @generated from field: com.neulink.pharmacy.UserDetails created_by = 8;
   */
  createdBy?: UserDetails;

  constructor(data?: PartialMessage<ShiftDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ShiftDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "message", T: Timestamp },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "system_ended", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "calculated_total_hours", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "details", kind: "message", T: ShiftInternalDetails },
    { no: 8, name: "created_by", kind: "message", T: UserDetails },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShiftDetails {
    return new ShiftDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShiftDetails {
    return new ShiftDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShiftDetails {
    return new ShiftDetails().fromJsonString(jsonString, options);
  }

  static equals(a: ShiftDetails | PlainMessage<ShiftDetails> | undefined, b: ShiftDetails | PlainMessage<ShiftDetails> | undefined): boolean {
    return proto3.util.equals(ShiftDetails, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ShiftInternalDetails
 */
export class ShiftInternalDetails extends Message<ShiftInternalDetails> {
  /**
   * @generated from field: com.neulink.pharmacy.DrawerAmount cash_drawer = 1;
   */
  cashDrawer?: DrawerAmount;

  /**
   * @generated from field: com.neulink.pharmacy.DrawerAmount card = 2;
   */
  card?: DrawerAmount;

  /**
   * @generated from field: string shift_name = 3;
   */
  shiftName = "";

  /**
   * @generated from field: string cash_register_id = 4;
   */
  cashRegisterId = "";

  /**
   * @generated from field: float payouts = 5;
   */
  payouts = 0;

  constructor(data?: PartialMessage<ShiftInternalDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ShiftInternalDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cash_drawer", kind: "message", T: DrawerAmount },
    { no: 2, name: "card", kind: "message", T: DrawerAmount },
    { no: 3, name: "shift_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "cash_register_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payouts", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShiftInternalDetails {
    return new ShiftInternalDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShiftInternalDetails {
    return new ShiftInternalDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShiftInternalDetails {
    return new ShiftInternalDetails().fromJsonString(jsonString, options);
  }

  static equals(a: ShiftInternalDetails | PlainMessage<ShiftInternalDetails> | undefined, b: ShiftInternalDetails | PlainMessage<ShiftInternalDetails> | undefined): boolean {
    return proto3.util.equals(ShiftInternalDetails, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.DrawerAmount
 */
export class DrawerAmount extends Message<DrawerAmount> {
  /**
   * @generated from field: float start_amount = 1;
   */
  startAmount = 0;

  /**
   * @generated from field: float end_amount = 2;
   */
  endAmount = 0;

  constructor(data?: PartialMessage<DrawerAmount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DrawerAmount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "end_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DrawerAmount {
    return new DrawerAmount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DrawerAmount {
    return new DrawerAmount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DrawerAmount {
    return new DrawerAmount().fromJsonString(jsonString, options);
  }

  static equals(a: DrawerAmount | PlainMessage<DrawerAmount> | undefined, b: DrawerAmount | PlainMessage<DrawerAmount> | undefined): boolean {
    return proto3.util.equals(DrawerAmount, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UserDetails
 */
export class UserDetails extends Message<UserDetails> {
  /**
   * @generated from field: int32 user_id = 1;
   */
  userId = 0;

  /**
   * @generated from field: string username = 2;
   */
  username = "";

  /**
   * @generated from field: string first_name = 3;
   */
  firstName = "";

  /**
   * @generated from field: string last_name = 4;
   */
  lastName = "";

  constructor(data?: PartialMessage<UserDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UserDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserDetails {
    return new UserDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserDetails {
    return new UserDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserDetails {
    return new UserDetails().fromJsonString(jsonString, options);
  }

  static equals(a: UserDetails | PlainMessage<UserDetails> | undefined, b: UserDetails | PlainMessage<UserDetails> | undefined): boolean {
    return proto3.util.equals(UserDetails, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SalesInShift
 */
export class SalesInShift extends Message<SalesInShift> {
  /**
   * @generated from field: string sale_id = 1;
   */
  saleId = "";

  /**
   * @generated from field: google.protobuf.Timestamp sale_time = 2;
   */
  saleTime?: Timestamp;

  /**
   * @generated from field: float grand_total = 3;
   */
  grandTotal = 0;

  constructor(data?: PartialMessage<SalesInShift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SalesInShift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sale_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sale_time", kind: "message", T: Timestamp },
    { no: 3, name: "grand_total", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SalesInShift {
    return new SalesInShift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SalesInShift {
    return new SalesInShift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SalesInShift {
    return new SalesInShift().fromJsonString(jsonString, options);
  }

  static equals(a: SalesInShift | PlainMessage<SalesInShift> | undefined, b: SalesInShift | PlainMessage<SalesInShift> | undefined): boolean {
    return proto3.util.equals(SalesInShift, a, b);
  }
}

